import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxShare = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M5.5 15a3.51 3.51 0 0 0 2.36-.93l6.26 3.58c-.08.276-.12.563-.12.85a3.53 3.53 0 1 0 1.14-2.57l-6.26-3.58a2.74 2.74 0 0 0 .12-.76l6.15-3.52A3.49 3.49 0 1 0 14 5.5c.004.287.044.573.12.85L8.43 9.6A3.5 3.5 0 1 0 5.5 15Zm12 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0-13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-12 6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
	})
});
export default SvgBxShare;
